module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"link":"원본보기"}}')
  delete Component.options._Ctor
}
